import { usePrevious } from '@ms/yammer-web-core-ui/dist/util/usePrevious';

import { isCachedAppPageLoadUrlHashPresent } from '../../../telemetry/cachedAppLoadUrlHash';

const useDidRoutedAppJustLoadFromCache = () => {
  const hash = location.hash;
  const previousHash = usePrevious(hash);

  return isCachedAppPageLoadUrlHashPresent() && hash !== previousHash;
};

const useDidRoutelessAppJustLoadFromCache = () => false;

interface UseDidAppJustLoadFromCacheProps {
  readonly isRoutelessApp: boolean;
}
type UseDidAppJustLoadFromCache = (props: UseDidAppJustLoadFromCacheProps) => boolean;
export const useDidAppJustLoadFromCache: UseDidAppJustLoadFromCache = ({ isRoutelessApp }) => {
  const didRoutedAppJustLoadCachedApp = useDidRoutedAppJustLoadFromCache();
  const didRoutelessAppJustLoadCachedApp = useDidRoutelessAppJustLoadFromCache();

  return isRoutelessApp ? didRoutelessAppJustLoadCachedApp : didRoutedAppJustLoadCachedApp;
};
